/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

import { Color, Object3D, Scene } from 'three';

export default class DebugScene extends Object3D {
    constructor() {
        super();

        this.scene = new Scene();
        this.scene.background = new Color().setHex(Math.random() * 0xffffff);

        this.time = 0;

        this.width = 1;
        this.height = 1;
    }

    setSize(width, height) {
        this.camera.aspect = width / height;
        this.camera.updateProjectionMatrix();
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    update(elapsed, delta) {
        // update
    }

    delete() {
        // delete
    }
}
